<script>
  import config from '../../libs/config.json';
  import { mapGetters, mapActions } from 'vuex'

  import axios from 'axios';
  
  import api from '../../api/public'
  import api_private from '../../api'

  import _system from '../../libs/system';

  import AOS from 'aos'
  import 'aos/dist/aos.css'
  import Axios from 'axios';

	export default 
	{
    name: 'authentication',
    data(){
      return {}
    },
    computed:{
      ...mapGetters('session', ['isLoggedIn', , 'getUser', 'getJwt'])
    },
    methods: {
        ...mapActions('session', ['login', 'setIsLoggedIn', 'setWorkspace']),
        ...mapActions('networks', ['setNetworks']),
        ...mapActions('statuses', ['setStatuses']),
        signInFunc()
        {
        if(!this.signIn.email.length || !this.signIn.password.length ){
            return alert('Inputs cannot be empty')
        }

          this.loading = true;
          
          //User Sign In
          api.post("/authentication/authenticate", this.signIn, (err, data) => {

              if(err) {
                console.log(err)
                this.loading = false
                this.error.message = err.data.message
                return this.error.email.invalid = true;
            }

             data.user.email = this.signIn.email;

              this.login({
                jwt: data.accessToken,
                user: data.user
              });
                                        
                                this.setIsLoggedIn();    
                                this.loaded = true
                                        
                                this.loading = false
                                this.$router.push({ "path": "accounts" });


          });
		    }
    },
    created(){

      if(this.$route.query.accessToken && this.$route.query.email){

        axios.get(config.url + '/api/v1/users/' + this.$route.query.email + '.email', {
        headers: {
          Authorization: 'Bearer ' + this.$route.query.accessToken
        }
        }).then((response) => {

              this.login({
                jwt: this.$route.query.accessToken,
                user: response.data
              });
                                        
              this.setIsLoggedIn();    
              this.$router.push({ "path": "inbox" });
          
        }).catch((error) => {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            this.$router.push({ "path": "signin" });
            // console.log(error.response.status);
            // console.log(error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$router.push({ "path": "signin" });
            console.log(error.request);
        }
});

      }else{
        window.location.href = '/signin'
      }
    }
	}
</script>

<template>

</template>


// WEBPACK FOOTER //
// src/components/auth/Authentication.vue